import { computePosition, shift } from '@floating-ui/dom';
import { A11yMenu2 } from '@barrierefrei/a11y-menu-2';
import { FvCustomEventNames } from '../../../ts/events';
import { throttle } from 'throttle-debounce';

/**
 * Friendation component
 * @param component Instance of this _Friendation_ component
 */
const BasisNavigation = (component: HTMLElement) => {
  /** Navigation element */
  const nav = component.querySelector('nav');
  if (!nav) return;

  const myMenu = new A11yMenu2({
    nav
  });

  const basisHeader = document.querySelector('[is="basis-header"]');

  myMenu.onEvent('onReady', () => {
    basisHeader.classList.remove('loading');
  });

  /** When the header closes, the navigation closes */
  document.addEventListener(FvCustomEventNames.BasisHeaderOut, () => {
    myMenu.closeAll();
  });

  const onResize = throttle(100, () => {
    // close the menu on resize. this is not really neccessary, but computePosition works less bad this way
    myMenu.closeAll();
  });

  window.addEventListener('resize', onResize);

  /**
   * Listen for dropdowns opening to position them accordingly
   */
  myMenu.onEvent('onSubmenuOpen', (options) => {
    const trigger = options.currentTrigger;

    /** Set position of the {@link submenu} */
    const submenu = options.currentSubmenu;

    computePosition(trigger, submenu, {
      middleware: [shift()]
    }).then(({ x }) => {
      Object.assign(submenu.style, {
        left: `${x}px`
      });
    });
  });
};

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-navigation"]';

/** Function that handles a single instance of this _Friendation_ component */
const classFunction: (component: HTMLElement) => void = BasisNavigation;

/**
 * Friendation component
 */
export const aBasisNavigation = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((x) => {
    classFunction.call(this, x);
  });
};
